import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import calendarImage from '../../../assets/images/calendar.svg';

import * as uiActions from '../../../store/actions/index';

const calendarBoxLarge = (props) => {

    const monthArray = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const dateFull = new Date(moment(props.date, 'YYYY-MM-DD').format('YYYY-MM-DD'));
    const month = dateFull.getUTCMonth();
    const year = dateFull.getUTCFullYear();
    let monthUpdated;

    for (let i = 0; i <= monthArray.length + 1; i++) {
        if (i === month) {
          monthUpdated = monthArray[i];
        }
    }

    return (
        <div onClick={() => {props.onToggleFullCalendar()}} className={`u-flex justify-content-center align-items-center u-cursorPointer pr-4 pb-2 pt-2 u-height100Percent`}>
            <img src={calendarImage} alt="Calendar" />
            <span className={`u-fontSize13 ml-2 u-textColorPrimary`}>{monthUpdated.toString().slice(0, 3)} {year} <span>&#9662;</span></span>
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onToggleFullCalendar: () => dispatch(uiActions.toggleFullCalendar())
    }
}

export default connect(null, mapDispatchToProps)(calendarBoxLarge);


// WEBPACK FOOTER //
// ./src/components/CalendarSmall/CalendarBoxLarge/CalendarBoxLarge.js